import { Component } from '@angular/core';
/**
* This component is used to display 404 message, when there is no route available
*/
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent{
}
